// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import i18n from './libs/vuei18n.js';
import vueLoading from './libs/loadingOverlay.js';
import 'iview/dist/styles/iview.css';
import '@/css/index.less';
import http from '@/js/http.js'
import until from '@/js/until.js'
import dictionary from '@/js/dictionary.js'
import config from '@/config'
import store from './store'
import localStore from 'store';
import showMoreBox from "@/components/showMore/showMore.vue"; //全局注册多选区域国家组件
import Dialog from "@/components/globalDialog/globalDialog.js"; //全局提示弹窗



import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'http://oss.chathot.me/action/404_avatar.png',
  loading: 'http://oss.chathot.me/action/avatar_loading.gif',
  attempt: 1
})
Vue.component("showMoreBox", showMoreBox);
Vue.use(Dialog);
Vue.prototype.$http=http
Vue.prototype.$config = config
Vue.prototype.$dictionary = dictionary

// // // // 显示更多
let showMore = function (text) {
  if (document.querySelector("#notice-1")) {
    return new Promise(resolve => {
      resolve(false);
    });
  }
  return this.$globalDialog({
    title: this.$i18n.tc("views.problems.detail"),
    okText: this.$i18n.tc("views.public.sure"),
    cancelText: this.$i18n.tc("views.public.cancel"),
    content: text,
    showIcon: false
  });
};

// 全局确认对话框
let modalCon = function (text,attention) {
  if (document.querySelector("#notice-1")) {
    return new Promise(resolve => {
      resolve(false);
    });
  }
  return this.$globalDialog({
    title: this.$i18n.tc("views.public.prompt"),
    okText: this.$i18n.tc("views.public.sure"),
    cancelText: this.$i18n.tc("views.public.cancel"),
    content: text,
    attention: attention,
    showIcon: true
  });
}



// 全局数据
Vue.prototype.$selfGlobal = {
  $globalStore: store,
  $globalI18n: i18n,
  $globalRequestMeth: {
    request: true,
    methodList: [],
  },
  checkBanLength: 5, // 封禁操作5个会出提示框
  $globalMethodArr: [], // 需要另外执行的方法可以推入该数组(封禁时操作用户信息用的)
  $localStore: localStore,
};
// until.phoneType()=='PC'?until.websiteAdaptive():until.adaptive()

// 全局方法
/**
 * params
 *  checkLength --- checkbox 选中的数量
 *  method --- 方法
 *  type --- 类型 。 默认checkbox，不是checkbox类型时不以选中数量 checkLength做判断，这时checkLength传null
 */
Vue.prototype.$globalMethods = {
  checkBanShowModal(checkLength, method, type='checkbox') {
    const selfGlobal = this.$selfGlobal;
    const showBanOperatFlag = this.$store.state.app.showBanOperatFlag;
    if (checkLength >= selfGlobal.checkBanLength && !showBanOperatFlag.show) {
      this.$store.commit('setShowBanOperatFlag', {
        show: true,
        count: checkLength,
        type: 'checkbox',
      });
      selfGlobal.$globalMethodArr.push({
        method,
        that: this,
      });
      return false;
    } else if (type === 'submit' && !showBanOperatFlag.show) {
      this.$store.commit('setShowBanOperatFlag', {
        show: true,
        count: 30,
        type: 'submit',
      });
      selfGlobal.$globalMethodArr.push({
        method,
        that: this,
      });
      return false;
    }
    return true;
  },
}

Vue.config.productionTip = false
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});
function getLocal(type) {
  return JSON.parse(localStorage.getItem(type));
}
function interfaceRegional(msg = {region: undefined, noList: undefined,noInt:false,additional:undefined}) {
  // region  获取区域名称
  // noList  需要过滤的区域
  // noInt  转字符串
  // additional  接口暂时不返回的
  const {region, noList,noInt,additional} = msg;
  var additionalList=[
    {id:13,text:'波斯语'},
  ]

  let list = getLocal("interfaceRegional");
  if (Array.isArray(additional)) {
    additionalList.forEach((item) => {
      if (additional.includes(Number(item.id))) {
        list.splice(list.length-1,0,item)
      }
    })
  }
  if(noInt){
    list.forEach((item)=>{
      item.id=item.id+''
    })
  }
  let newArray = []

  let results = [];
  let nameList = [];
  if (Array.isArray(region)) {
    for (let i in region) {
      results.push(list.find(item => item.id === Number(region[i])));
    }
  } else {
    let reg=region+''
    results.push(list.find(item => item.id === Number(reg)));
  }
  results.forEach(item => {
    if (item) {
      nameList.push(item.text);
    }
  });

  if (Array.isArray(noList)) {
    list.forEach((item) => {
      if (!noList.includes(Number(item.id))) {
        newArray.push(item)
      }
    })
  }

  return region!==undefined? nameList.join() : Array.isArray(noList) ? newArray : list;

}

function localSelectRegion(){
  // 0英语 1阿语 2印尼语 3土耳其语 4印地语 5越南语 6泰语
  return [
    {
      value: -1,
      label: this.$i18n.t("views.public.all"),
    },
    {
      value: 0,
      label: this.$i18n.t("views.communityLanguage.language1Area"),
    },
    {
      value: 1,
      label: this.$i18n.t("views.communityLanguage.language2Area"),
    },
    {
      value: 3,
      label: this.$i18n.t("views.communityLanguage.language4Area"),
    },
    {
      value: 4,
      label: this.$i18n.t("views.communityLanguage.language5Area"),
    },
    {
      value: 5,
      label: this.$i18n.t("views.communityLanguage.language6Area"),
    },
    {
      value: 6,
      label: this.$i18n.t("views.communityLanguage.language7Area"),
    },
    {
      value: 9,
      label: this.$i18n.t("views.communityLanguage.language9Area"),
    },
    {
      value: 10,
      label: this.$i18n.t("views.communityLanguage.language10Area"),
    },
    {
      value: 11,
      label: this.$i18n.t("views.communityLanguage.language11Area"),
    },
  ];
}



// 获取权限设置
let getauth = function (id) {
  let list = JSON.parse(localStorage.getItem("authListBackStage")) || [];
  // console.log('backstage',list)
  if (list.length === 0){
    return true
  }
  let data = false;
  list.forEach(item => {
    if (Number(item) == id) {
      data = true;
    }
  });
  return data;
};

Vue.prototype.$modalCon = modalCon;
Vue.prototype.$interfaceRegional = interfaceRegional;
Vue.prototype.$localRegion = localSelectRegion;
Vue.prototype.getauth = getauth;

Vue.prototype.$showMore = showMore;
Vue.prototype.firstLogin = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js